import React, { lazy } from 'react';
import { School, Building2, Globe2 } from 'lucide-react';
export const WhoWeTrain = () => {
  const audiences = [{
    title: 'Schools',
    icon: <School className="w-10 h-10 text-white" data-id="element-1433" data-mp="3j4h496a8fdoh" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    items: ['Teacher development', 'Student leadership programs', 'School communications teams']
  }, {
    title: 'Companies & Startups',
    icon: <Building2 className="w-10 h-10 text-white" data-id="element-1434" data-mp="30d6ggxzszh0t" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    items: ['Marketing teams', 'Leadership teams', 'HR teams', 'Professional development']
  }, {
    title: 'Organizations & NGOs',
    icon: <Globe2 className="w-10 h-10 text-white" data-id="element-1435" data-mp="2ckpwghwi9eyv" />,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    items: ['Program teams', 'Communications teams', 'Community managers', 'Project teams']
  }];
  return <section className="py-20 bg-white border-y border-gray-100" data-id="element-1436" data-mp="3aa9xzp6f4fb2">
      <div className="container mx-auto px-4" data-id="element-1437" data-mp="3a8gsid7jk14n">
        <div className="text-center mb-16 scroll-animate" data-id="element-1438" data-mp="3697z59gey59m">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1439" data-mp="366lpn49ypfor">
            Who We Train
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1440" data-mp="2was630xtslxh">
            Tailored capacity building for diverse institutional needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1441" data-mp="2rbp8g1k6dhzj">
          {audiences.map((audience, index) => <div key={index} className="scroll-animate relative rounded-2xl overflow-hidden group hover:shadow-xl transition-all duration-300 min-h-[380px] flex flex-col justify-end" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-1442" data-mp="2nc6rthzdzt2i" data-mpi={index}>
              {/* Background image */}
              <img src={audience.image} alt={audience.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-1443" data-mp="2jsodi4nfwwns" />
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/50 to-black/20" data-id="element-1444" data-mp="2xsz3z6ku898f"></div>

              {/* Content */}
              <div className="relative z-10 p-8" data-id="element-1445" data-mp="2oqzowjtdvf84">
                <div className="w-14 h-14 bg-white/15 backdrop-blur-sm rounded-xl flex items-center justify-center mb-5 border border-white/20" data-id="element-1446" data-mp="2oq7rd3g877f7">
                  {audience.icon}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1447" data-mp="1db1bk3r6a713">
                  {audience.title}
                </h3>
                <ul className="space-y-3" data-id="element-1448" data-mp="1ic8ffrq72m2h">
                  {audience.items.map((item, i) => <li key={i} className="flex items-center text-gray-200" data-id="element-1449" data-mp="19s3mfm74a6mz" data-mpi={i}>
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mr-3 flex-shrink-0" data-id="element-1450" data-mp="15rjpojqgh51d"></span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};